import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { spacing } from "@every.org/common/src/display/spacing";

import { cssForMediaSize, MediaSize } from "src/theme/mediaQueries";
import { textSizeCss } from "src/theme/text";

export const Headline = styled.h1`
  text-align: center;
  ${textSizeCss.l};

  padding: ${spacing.m} 0;

  ${cssForMediaSize({
    min: MediaSize.MEDIUM,
    css: css`
      padding: ${spacing.xl} 0;
    `,
  })}

  ${cssForMediaSize({
    min: MediaSize.SMALL,
    css: textSizeCss.xl,
  })}
`;

export const HeaderCardMetadata = styled.div`
  display: flex;
  align-items: center;
  max-width: 500px;
  height: 100%;
`;
